module.exports = __webpack_public_path__ + "media/images/3_1-3e577b795b2c9ee7179ce237a5018148.png";